import { render, staticRenderFns } from "./CouponExpireTip.vue?vue&type=template&id=2c978789&"
import script from "./CouponExpireTip.vue?vue&type=script&lang=js&"
export * from "./CouponExpireTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports